import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { DashboardOutlined, EditOutlined, FileSearchOutlined } from '@ant-design/icons';

const { Sider } = Layout;

const Sidebar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const handleMouseEnter = () => {
    setCollapsed(false);
  };

  const handleMouseLeave = () => {
    setCollapsed(true);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <Sider
      width={collapsed ? 80 : 200}  // Adjust the width based on the collapsed state
      theme="dark"
      collapsed={collapsed}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div style={{ height: '32px', textAlign: 'center', lineHeight: '32px', color: '#fff' }}>
        Far Tech Admin
      </div>
      <Menu mode="vertical" theme="dark" selectedKeys={[location.pathname]}>
        <Menu.Item key="/customer_dashboard" icon={<DashboardOutlined />} className={isActive('/customer_dashboard') ? 'active' : ''}>
          <Link to="/customer_dashboard">Dashboard</Link>
        </Menu.Item>
        <Menu.Item key="/edit_profile" icon={<EditOutlined />} className={isActive('/edit_profile') ? 'active' : ''}>
          <Link to="/edit_profile">Edit Profile</Link>
        </Menu.Item>
        <Menu.Item key="/view_contract" icon={<FileSearchOutlined />} className={isActive('/view_contract') ? 'active' : ''}>
          <Link to="/view_contract">View Contract</Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export default Sidebar;


